/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerListReportsQueryResponse, IncidentInvestigationControllerListReportsPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerListReports";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerListReports } from "../../clients/incident-agentService/incidentInvestigationControllerListReports";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerListReportsQueryKey = (id: IncidentInvestigationControllerListReportsPathParams["id"]) => [{
  url: '/api/v1/incident-agent/investigations/:id/reports',
  params: {
    id: id
  }
}] as const;
export type IncidentInvestigationControllerListReportsQueryKey = ReturnType<typeof incidentInvestigationControllerListReportsQueryKey>;
export function incidentInvestigationControllerListReportsQueryOptions(id: IncidentInvestigationControllerListReportsPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerListReportsQueryKey(id);
  return queryOptions<IncidentInvestigationControllerListReportsQueryResponse, ResponseErrorConfig<Error>, IncidentInvestigationControllerListReportsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerListReports(id, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/reports}
 */
export function useIncidentInvestigationControllerListReports<TData = IncidentInvestigationControllerListReportsQueryResponse, TQueryData = IncidentInvestigationControllerListReportsQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerListReportsQueryKey>(id: IncidentInvestigationControllerListReportsPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerListReportsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerListReportsQueryKey(id);
  const query = useQuery({
    ...incidentInvestigationControllerListReportsQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}